import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Toc as TocIcon } from '@mui/icons-material';
import { Card, NavPills } from '@totalsoft/rocket-ui';
import { NavPillsCardContainer } from 'components/common/Styles';
import BaseTypesContainer from './baseTypes/BaseTypesContainer';
import { get } from '@totalsoft/change-tracking-react';
import PropertiesContainer from './properties/PropertiesContainer';

const PartnerTypeDetailsComponent = ({ lens, initialData, disabled, validation, onChangeProperty, onDeleteProperty }) => {
  const [t] = useTranslation();
  const [active, setActive] = useState(0);

  const partnerTypeId = typeof (lens.id |> get) === 'string' ? null : lens.id |> get;

  return (
    <Card icon={TocIcon} iconColor='primary' title={lens.name |> get}>
      <NavPillsCardContainer disablePadding>
        <NavPills
          fullWidth
          active={active}
          onChange={(_event, active) => {
            setActive(active);
          }}
          tabs={[
            {
              label: t('PartnerType.Details.PartnerBaseType.Title'),
              content: (
                <BaseTypesContainer
                  partnerTypeId={partnerTypeId}
                  editing={lens.editing |> get}
                  lens={lens.baseTypes}
                  validation={validation}
                />
              )
            },
            {
              label: t('PartnerType.Details.PartnerTypeXProperty.Title'),
              content: (
                <PropertiesContainer
                  partnerTypeId={partnerTypeId}
                  lens={lens.properties}
                  initialData={initialData}
                  validation={validation}
                  disabled={disabled}
                  onChangeProperty={onChangeProperty(partnerTypeId)}
                  onDeleteProperty={onDeleteProperty}
                />
              )
            }
          ]}
        />
      </NavPillsCardContainer>
    </Card>
  );
};

PartnerTypeDetailsComponent.propTypes = {
  lens: PropTypes.object.isRequired,
  initialData: PropTypes.object,
  disabled: PropTypes.bool,
  validation: PropTypes.object,
  onChangeProperty: PropTypes.func,
  onDeleteProperty: PropTypes.func
};

export default PartnerTypeDetailsComponent;
